import script from "./testimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./testimonial.vue?vue&type=script&setup=true&lang=js"

import "./testimonial.vue?vue&type=style&index=0&id=114b079e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114b079e"]])

export default __exports__